import React from 'react';
import { ExclamationTriangleIcon, DocumentArrowDownIcon } from '@heroicons/react/24/outline';

interface ExportModalProps {
  isOpen: boolean;
  totalResults: number;
  exportType: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ExportModal: React.FC<ExportModalProps> = ({
  isOpen,
  totalResults,
  exportType,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  const willBeTruncated = totalResults > 1000;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-full md:w-1/2 shadow-lg rounded-md bg-white">
        <div className="mt-3 text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
            {willBeTruncated ? (
              <ExclamationTriangleIcon className="h-6 w-6 text-amber-600" />
            ) : (
              <DocumentArrowDownIcon className="h-6 w-6 text-blue-600" />
            )}
          </div>
          
          <h3 className="text-lg leading-6 font-medium text-gray-900 mt-4">
            Export Excel - {exportType}
          </h3>
          
          <div className="mt-4 px-7 py-3">
            <p className="text-sm text-gray-600 mb-3">
              Nombre total de résultats : <span className="font-semibold">{totalResults.toLocaleString()}</span>
            </p>
            
            {willBeTruncated ? (
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-4">
                <div className="flex">
                  <ExclamationTriangleIcon className="h-5 w-5 text-amber-400 mr-2 mt-0.5 flex-shrink-0" />
                  <div className="text-sm text-amber-800">
                    <p className="font-medium">Attention :</p>
                    <p>L'export sera limité aux 1000 premiers résultats. Affinez vos critères de recherche pour obtenir un export complet.</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-green-50 border border-green-200 rounded-md p-3 mb-4">
                <div className="flex">
                  <DocumentArrowDownIcon className="h-5 w-5 text-green-400 mr-2 mt-0.5 flex-shrink-0" />
                  <div className="text-sm text-green-800">
                    <p>Tous les résultats seront inclus dans l'export Excel.</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="flex justify-center space-x-3 px-4 py-3">
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Annuler
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {willBeTruncated ? 'Exporter (1000 résultats)' : 'Exporter'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportModal; 